import { deferScript } from '@confluence/dom-helpers';

export class ResourceRecorder {
	protected resource: string;

	constructor() {
		this.resource = '';
	}

	reset(): void {
		this.resource = '';
	}

	add(resource: string) {
		this.resource += resource;
		return this;
	}

	addDeferTags(tags: string) {
		this.resource += deferScript(tags);
		return this;
	}

	get(): string {
		return this.resource;
	}
}
